var ko = require('knockout');
var $ = require('jquery');

ko.components.register('shopping-cart', {
  viewModel: require('./shopping-cart'),
  template: require('./shopping-cart.template')
});

$('[data-shopping-cart]').each(function() {
  ko.applyBindings({}, this);
});
